<template>
  <div class="event-banner-container">
    <div
      v-if="eventBannerType === EVENT_TYPE.POT_BONUS"
      class="event-banner-row pot-bonus"
    >
      <div class="prizing-panel">
        <span class="price">
          <span style="font-size: 17px;">*&nbsp;</span>{{ formattedPrize }}
        </span>
        <span class="desc">prizing<br>total</span>
      </div>
      <div class="bonus-panel">
        <span style="font-size: 16px">+&nbsp;</span>pot bonus
      </div>
    </div>
    <div v-else class="event-banner-row" :style="(formattedPrize.length > 7) ? 'max-width: 151px;' : ''">
      <div class="prizing-panel" :style="(formattedPrize.length > 7) ? 'flex-wrap: wrap;' : ''">
        <span class="price" :style="(formattedPrize.length > 7) ? 'margin-top: -5px; margin-right: 0;' : ''"> {{ formattedPrize }} </span>
        <span
          v-if="eventBannerType === EVENT_TYPE.POT_SO_FAR && formattedPrize.length <= 7"
          class="desc"
        >* pot<br>so far</span>
        <span v-if="eventBannerType === EVENT_TYPE.POT_SO_FAR && formattedPrize.length > 7" class="desc" style="margin-left: 15px; margin-top: -5px; margin-bottom: 5px;">* pot so far</span>
        <span v-if="formattedPrize.length > 7" class="desc" style="margin-left: 15px; margin-top: -7px;">prize pool</span>
        <span v-else class="desc">prize<br>pool</span>
      </div>
    </div>
  </div>
</template>
<script>
import { component } from '../../mixins/component';

export default {
  mixins: [component],
  props: {
    event: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    eventBannerType: function() {
      if (!this.event.is_paid_tournament) {
        return this.EVENT_TYPE.DEFAULT;
      }
      if (this.event.paid_event_type === 'static') {
        return this.EVENT_TYPE.PRIZE_POOL;
      }
      if (!this.event.award_pool_amount) {
        return this.EVENT_TYPE.POT_SO_FAR;
      }
      return this.EVENT_TYPE.POT_BONUS;
    },
    formattedPrize: function() {
      const prizePool = this.event.prize_pool_amount;
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return formatter.format(prizePool);
    },
  },
  created() {
    this.EVENT_TYPE = {
      DEFAULT: 0,
      POT_BONUS: 1,
      POT_SO_FAR: 2,
      PRIZE_POOL: 3,
    };
  },
};
</script>
